module.exports = __webpack_public_path__ + "img/Monte_Kope_102.d25b93b5.jpg";